var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Select',_vm._b({attrs:{"allowEmpty":true,"label":"combined_sku_name","placeholder":"parts","track-by":"id","multi":true},on:{"input":_vm.update}},'Select',{value: _vm.value, request: _vm.request},false))}
var staticRenderFns = []

export { render, staticRenderFns }